module.exports = [{"key":"function","name":"职能","data":[{"key":"1","name":"集团门户"},{"key":"2","name":"个人门户"},{"key":"3","name":"知识门户"},{"key":"4","name":"党群门户"},{"key":"5","name":"分公司门户"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/mocks/home/datas_category_portal.json
// module id = 1371
// module chunks = 0